"use strict";

module.exports = function () {
    var state = {
        page: 1,
        query: this.query,
        orderBy: this.orderBy,
        perPage: this.opts.perPage,
        customQueries: this.customQueries
    };

    this.storage.setItem(this.stateKey, JSON.stringify(state));

    return state;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/init-state.js